import {Input} from "./Input";
import '../../sass/components/_searchField.scss';

export const SearchField = {
    name: 'SearchField',
    components: {
        Input
    },
    props: {
        name: String,
        value: String,
    },
    template: `
        <div class="search-field">
            <Input type="search" 
                    :name="name"
                    :value="value"
                    class="search-field__input"
                    v-on="$listeners"
                    v-bind="$attrs"
                    /> 
            <button type="submit" class="search-field__button">Search</button>
        </div>
    `
}